export default __webpack_public_path__ + "static/media/eyecam-co.0abb14e8.svg";